import { createContext } from 'react'

export const ActionSheetFrame = createContext<{ container: HTMLElement | null; depth: number } | null>(null)
